/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBillingPlanEvaluation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBillingPlanEvaluation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBillingPlanEvaluation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBillingPlanEvaluation>): BackgroundJobPayloadForBillingPlanEvaluation {
        let obj = Object.assign(new BackgroundJobPayloadForBillingPlanEvaluation(), model);
        BackgroundJobPayloadForBillingPlanEvaluation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBillingPlanEvaluation>): BackgroundJobPayloadForBillingPlanEvaluation {
        if (!model) return null;
        return BackgroundJobPayloadForBillingPlanEvaluation.newInstance(<BackgroundJobPayloadForBillingPlanEvaluation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBillingPlanEvaluation) {
        if (!obj) return;

        models.BackgroundJobPayloadForBillingPlanEvaluation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBillingPlanEvaluation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBillingPlanEvaluation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Service account ID
     */
    service_account_id: string;

    /**
     * Start date of billing data
     */
    start_date: Date;

    /**
     * End date of billing data
     */
    end_date: Date;

    /**
     * List of modified line items
     */
    modified_line_items: Array<string>;

}
